import StartRequestBase from "../components/StartRequestBase";

const VermostOutsiderStartBondRequest = () => (
  <StartRequestBase variant="creation" />
);

export default VermostOutsiderStartBondRequest;
